/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*// Script to add a single product to the cart
function _addMeToCart(e, el) {
  e = e || window.event;
  e.preventDefault();

  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'quantity': 1
      }
    ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((resp) => {
      return resp.json();
    })
    .then((data) => {
      // Trigger the "product:added" event
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: data
        }
      }));

      // Trigger the sidebar popout (you may need to adapt this part)
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    })
    .catch((err) => {
      console.error('Error: ' + err);
    });
}*/

// Script to add a single product to the cart with Rebuy
function _addMeToCart(e, el) {
  e = e || window.event;
  e.preventDefault();

  let formData = {
    'items': [
      {
        'id': el.dataset.variant_id,
        'quantity': 1
      }
    ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((resp) => {
      return resp.json();
    })
    .then((data) => {
      // Trigger the "product:added" event
      document.dispatchEvent(new CustomEvent('product:added', {
      }));
    })
    .catch((err) => {
      console.error('Error: ' + err);
    });
}

// Standard function definition for adding multiple variants to the cart
function _addMultipleVariantsToCart(e, el, sectionId) {
  e.preventDefault();

  const ulId = `variantRadioButtons-${sectionId}`;
  const variantRadioButtons = document.querySelectorAll(`#${ulId} input[type="radio"]:checked`);

  const lineItems = Array.from(variantRadioButtons).map(radioButton => ({
    variantId: radioButton.value,
    quantity: 1
  })).reverse();

  if (lineItems.length === 0) {
    console.error('No variants selected.');
    return;
  }

  if (window.Tapcart && window.Tapcart.isInitialized) {
    // Add items to cart via Tapcart
    window.Tapcart.actions.addToCart({ lineItems });

    // Assuming the addToCart action is synchronous or does not support promises,
    // Navigate to the cart screen immediately after adding items
    window.Tapcart.actions.openScreen({
      destination: { type: "internal", url: "/cart" }
    });

    // Show toast message after navigating to the cart
    window.Tapcart.actions.showToast({
      message: 'Discounted kit price will apply at checkout',
      type: 'success' // Could be "success" or "error" based on context
    });
  } else {
    // Standard web add-to-cart functionality using Shopify’s API
    let formData = {
      'items': lineItems.map(item => ({ id: item.variantId, quantity: item.quantity }))
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      document.dispatchEvent(new CustomEvent('product:added', {
        detail: { variant: data }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(error => console.error('Error adding to cart:', error));
  }
}


function updateTotalPricesForSections() {
  // Find all kit sections on the page
  const kitSections = document.querySelectorAll('.FeaturedKit_KitsWrapper');

  kitSections.forEach(function(kitSection) {
    // Read the discount amount from the data attribute
    const discountAmount = parseFloat(kitSection.getAttribute('data-discount')) || 0;

    // Find all product blocks within the section
    const blocks = kitSection.querySelectorAll('.FeaturedKit');
    const buttons = kitSection.querySelectorAll('.ProductForm__AddToCart');

    // Determine if the kit is sold out
    const isSoldOut = Array.from(buttons).some(button => button.disabled);

    if (isSoldOut) {
      // Update all buttons to "JUST sold out"
      buttons.forEach(button => {
        button.textContent = 'SOLD OUT';
      });
    } else {
      let totalPrice = 0;
      let originalPrice = 0;

      blocks.forEach(function(block) {
        const productPrice = parseFloat(block.getAttribute('data-product-price'));

        if (!isNaN(productPrice)) {
          originalPrice += productPrice;
          totalPrice += productPrice;
        }
      });

      // Apply the discount
      if (discountAmount > 0) {
        totalPrice = totalPrice * (1 - discountAmount / 100);
      }

      // Round up to the nearest whole dollar
      totalPrice = Math.ceil(totalPrice);

      // Update all buttons with new price information
      buttons.forEach(button => {
        // Clear previous content
        button.innerHTML = ''; 

        // Create new elements for the add to cart text, price, and original price
        const addToCartText = document.createElement('span');
        addToCartText.textContent = 'Add to cart';
        
        const separator = document.createElement('span');
        separator.className = 'Button__SeparatorDot';
        separator.textContent = '';

        const totalPriceElement = document.createElement('span');
        totalPriceElement.className = 'TotalPrice';
        totalPriceElement.textContent = `$${totalPrice.toFixed(0)}`;

        const originalPriceElement = document.createElement('span');
        originalPriceElement.className = 'Price--compareAt';
        originalPriceElement.textContent = `$${originalPrice.toFixed(0)}`;
        originalPriceElement.style.textDecoration = 'line-through';

        // Append new elements to the button
        button.appendChild(addToCartText);
        button.appendChild(separator);
        button.appendChild(totalPriceElement);
        button.appendChild(originalPriceElement);
      });
    }
  });
}

// Call the function once the document is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  updateTotalPricesForSections();
});

// Optionally call the function whenever you need to update the total prices
// For example, if you add/remove products dynamically
// updateTotalPricesForSections();




// Handle modal background click to close the modal
document.addEventListener('click', function (event) {
    // Find the closest modal parent of the clicked element
    const modal = event.target.closest('.Modal.Modal--fullScreen.Modal--pageContent');

    // Only proceed if a modal was found
    if (modal) {
        const closeButton = modal.querySelector('.Modal__Close.size-chart-close');
        
        if (event.target === modal) {
            // Programmatically trigger a click event on the close button
            closeButton.click();
        }
    }
});

// Handle click events for buttons that trigger modals
document.addEventListener('click', function (event) {
    // Check if the clicked element has the data-action attribute set to 'open-modal'
    if (event.target.getAttribute('data-action') === 'open-modal') {
        // Get the value of aria-controls from the clicked button
        const ariaControls = event.target.getAttribute('aria-controls');

        // Find the corresponding modal element using the aria-controls value
        const modal = document.getElementById(ariaControls);

        if (modal) {
            // Open the modal
            modal.setAttribute('aria-hidden', 'false');
            // Add code to display the modal (e.g., add a CSS class for visibility)
        }
    }

    // Check if the clicked element has the data-action attribute set to 'close-modal'
    if (event.target.getAttribute('data-action') === 'close-modal') {
        // Get the value of aria-controls from the clicked button
        const ariaControls = event.target.getAttribute('aria-controls');

        // Find the corresponding modal element using the aria-controls value
        const modal = document.getElementById(ariaControls);

        if (modal) {
            // Close the modal
            modal.setAttribute('aria-hidden', 'true');
            // Add code to hide the modal (e.g., remove the CSS class for visibility)
        }
    }
});